import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { PRESCHOOL } from 'constants/schoolTypes';
import { setPageTitle } from 'actions/header';
import WelcomeMessage from 'containers/WelcomeMessage';
import MyPosts from './Sections/MyPosts';
import MyPlans from './Sections/MyPlans';
import MyAssignments from './Sections/MyAssignments';
import Schedule from '../Schedule/Schedule';
import { InView } from 'react-intersection-observer';
import LoadingCard from 'components/Cards/LoadingCard';

var Overview = /*#__PURE__*/function (_Component) {
  _inherits(Overview, _Component);

  var _super = _createSuper(Overview);

  function Overview(props) {
    _classCallCheck(this, Overview);

    return _super.call(this, props);
  }

  _createClass(Overview, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.setPageTitle(this.props.translate('home-navitem-overview'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var school = this.props.user.schools.find(function (school) {
        return school.id == _this.props.activeSchool;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement(WelcomeMessage, null), this.props.services.news ? /*#__PURE__*/React.createElement("div", {
        className: "section"
      }, /*#__PURE__*/React.createElement(MyPosts, {
        overview: true
      })) : null, this.props.services.plans ? /*#__PURE__*/React.createElement("div", {
        className: "section"
      }, /*#__PURE__*/React.createElement(MyPlans, {
        dateRestriction: true,
        overview: true
      })) : null, (this.props.services.haldor || this.props.services.microsoft) && school.type != PRESCHOOL ? /*#__PURE__*/React.createElement(InView, {
        as: "div",
        delay: 850,
        triggerOnce: true
      }, function (_ref) {
        var inView = _ref.inView,
            ref = _ref.ref,
            entry = _ref.entry;
        return /*#__PURE__*/React.createElement("div", {
          className: "section",
          ref: ref
        }, inView ? /*#__PURE__*/React.createElement(MyAssignments, {
          limit: 9,
          overview: true
        }) : /*#__PURE__*/React.createElement(LoadingCard, {
          count: 1
        }));
      }) : null, this.props.services.schedule && school.type != PRESCHOOL ? /*#__PURE__*/React.createElement(InView, {
        as: "div",
        delay: 1000,
        triggerOnce: true
      }, function (_ref2) {
        var inView = _ref2.inView,
            ref = _ref2.ref,
            entry = _ref2.entry;
        return /*#__PURE__*/React.createElement("div", {
          className: "section",
          ref: ref
        }, inView ? /*#__PURE__*/React.createElement(Schedule, {
          overview: true
        }) : /*#__PURE__*/React.createElement(LoadingCard, {
          count: 1
        }));
      }) : null);
    }
  }]);

  return Overview;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    services: state.Services.availableServices,
    activeSchool: state.user.activeSchool
  };
}

export default connect(mapStateToProps, {
  setPageTitle: setPageTitle
})(Overview);